import {db} from '../../../utils/firebase';

export const saveLang = (language, fetchingState, setFetchingState, errors, setErrors) => {
    let isDataSent;
    setFetchingState({...fetchingState, languages: true});

    return db
        .collection('languages')
        .doc(`${language.languageId}`)
        .set({languageId: language.languageId, represent: language.represent})
        .then(() => isDataSent = true)
        .catch(error => {
            setErrors({...errors, languages: error});
            return isDataSent = false;
        })
        .finally(() => {
            setFetchingState({...fetchingState, languages: false});
            return isDataSent;
        });
}

export const getLang = (fetchingState, setFetchingState, errors, setErrors) => {
    setFetchingState({...fetchingState, languages: true});

    return db
        .collection('languages')
        .get()
        .then((snapshot) => {
            const languages = [];
            snapshot.forEach((doc) => {
                languages.push({id: doc.id, data: doc.data()})
            });
            return languages;
        })
        .catch(error => setErrors({...errors, languages: error}))
        .finally(() =>
            setFetchingState({...fetchingState, languages: false})
        );
}

export const checkIfLangCollectionExists = (tipsCollectionName, fetchingState, setFetchingState, errors, setErrors) => {
    setFetchingState({...fetchingState, languages: true});

    return db
        .doc(`tipsCollection/${tipsCollectionName}`)
        .get()
        .then((doc) => doc.exists)
        .catch(error => setErrors({...errors, languages: error}))
        .finally(() => setFetchingState({...fetchingState, languages: false}));
}

export const setNewTipsLangCollection = (tipsCollectionName, fetchingState, setFetchingState, errors, setErrors) => {
    let isDataSent;
    setFetchingState({...fetchingState, languages: true});

    return db
        .doc(`tipsCollection/${tipsCollectionName}`)
        .set({tipsArray: []})
        .then(() => isDataSent = true)
        .catch(error => {
            setErrors({...errors, languages: error});
            return isDataSent = false;
        })
        .finally(() => {
            setFetchingState({...fetchingState, languages: false});
            return isDataSent;
        });
}
